import { useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const VideoUploader = ({ uploadEndpoint, refreshVideos }) => {
    const axiosPrivate = useAxiosPrivate();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploading, setUploading] = useState(false);

    const handleFileChange = (e) => {
        setSelectedFiles(Array.from(e.target.files));
    };

    const handleUpload = async () => {
        if (selectedFiles.length === 0) return;
        setUploading(true);

        const form = new FormData();
        selectedFiles.forEach(file => form.append("videos", file));

        try {
            await axiosPrivate.post(uploadEndpoint, form, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            setSelectedFiles([]);
            refreshVideos();
        } catch (err) {
            console.error("Upload failed", err);
            alert("Upload failed");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="videoUploader">
            <input
                type="file"
                accept="video/*"
                multiple
                onChange={handleFileChange}
            />
            <button onClick={handleUpload} disabled={uploading}>
                {uploading ? "Uploading..." : "Upload Videos"}
            </button>
        </div>
    );
};

export default VideoUploader;
